import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { callbacks, hooks } from '../../../config/api';
import { isHttpSuccess } from '../../utils/isHttpSuccess';
import { FAILED_ARCHIVE_MESSAGE, SUCCESSFUL_ARCHIVE_MESSAGE } from '../constants';
export var useArchiveInsurance = function useArchiveInsurance() {
  var invalidateQueries = hooks.useInvalidateQueries();
  var _hooks$useUpdateRecor = hooks.useUpdateRecord('insurance', {
      mutationConfig: {
        onError: function onError() {
          return callbacks.toast.error(FAILED_ARCHIVE_MESSAGE);
        },
        onSettled: function onSettled() {
          invalidateQueries('insurance');
          invalidateQueries('plan');
        }
      }
    }),
    updateRecord = _hooks$useUpdateRecor.updateRecord;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var updateResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return updateRecord(id, {
              state: 'archived'
            });
          case 2:
            updateResponse = _context.sent;
            if (isHttpSuccess(updateResponse.status)) {
              callbacks.toast.success(SUCCESSFUL_ARCHIVE_MESSAGE);
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
//# sourceMappingURL=useArchiveInsurance.js.map